import { render, staticRenderFns } from "./UserActionsLog.vue?vue&type=template&id=5db31578&scoped=true&lang=pug"
import script from "./UserActionsLog.vue?vue&type=script&lang=js"
export * from "./UserActionsLog.vue?vue&type=script&lang=js"
import style0 from "./UserActionsLog.vue?vue&type=style&index=0&id=5db31578&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db31578",
  null
  
)

export default component.exports